import React from 'react'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import MyPurchases from '../MyPurchases/index'
import { Bg, MainLayout, ContentLayout } from './styledComponents'

const MyPurchasesPage = () => (
  <Bg>
    <SideBar />
    <MainLayout>
      <ContentLayout>
        <MyPurchases />
      </ContentLayout>
    </MainLayout>
  </Bg>
)

export default MyPurchasesPage
